"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const hex_1 = __importDefault(require("./hex"));
exports.hex = hex_1.default;
const b64_1 = __importDefault(require("./b64"));
exports.b64 = b64_1.default;
const utf8_1 = __importDefault(require("./utf8"));
exports.utf8 = utf8_1.default;
// --
exports.hexToBase64url = (input) => {
    return b64_1.default.encode(hex_1.default.decode(input));
};
exports.base64ToHex = (base64) => {
    return hex_1.default.encode(b64_1.default.decode(base64));
};
exports.encoders = {
    base64: b64_1.default.encode,
    utf8: utf8_1.default.decode,
    hex: hex_1.default.encode
};
exports.decoders = {
    base64: b64_1.default.decode,
    utf8: utf8_1.default.encode,
    hex: hex_1.default.decode
};
